<div class="iss-side-nav-footer" *ngIf="template">
  <div class="iss-side-nav-footer-content">
    <div class="iss-container">
      <ng-container [ngTemplateOutlet]="template"/>
    </div>
  </div>
</div>
